export default __webpack_public_path__ + "static/170-ba7561b1b12b603bea789d1d6b7c0430.jpg";